import React, { useEffect, useState } from 'react'
import { autoTransPageTab, autoTransPageTabIds, reportsPageTab, reportsPageTabIds } from '../GSConstants'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useSearchParams } from 'react-router-dom'
import GstInvoiceCofigPage from './GSTInvoiceCongiguration/GstInvoiceCofigPage'
import MonthlyTargetTable from './MonthlyTarget/MonthlyTargetTable'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
  
export const reportsPageTabWithId = [{name:'GST Invoice Configuration',JobID:520},{name:'Monthly Target',JobID:425}]
const GSReportsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id'))||520)
    const [allTabs, setAllTabs] = useState([])

    useEffect(() => {
      const allGSPages = sessionStorage.getItem('token1');
      const allGSPagesActive = JSON.parse(allGSPages);
      // if (selectedTab === '' || selectedTab === undefined) {
      //   const newData = standardRateTabs.filter((item) => findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null)
      //   goToTabs(newData?.[0]?.JobID, {})
      // }
  
      if (allGSPagesActive?.length > 0) {
        setAllTabs(allGSPagesActive)
      } else {
        setAllTabs([])
      }
    }, [selectedTab]);
    useEffect(() => {
    if (selectedTab === "") {
      goToTabs(520)
    }
  }, [searchParams])
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }
    const getReportsPageContent = (typeId,label) => {
      switch (typeId) {
          case 520:
             return <GstInvoiceCofigPage/>
             break
          case 425:
              return <MonthlyTargetTable />
              break
          default:
          return label
      }
    }
  return (
    <>
      <Box className='autoTransPageTabContainer'>
        <Item sx={{paddingTop:0}}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedTab} onChange={(e,newValue)=>goToTabs(newValue)} aria-label="bsic tabs example">
              {reportsPageTabWithId.map((reqType, index) => (
                <Tab  
                key={`sender_${reqType.JobID}`}
                value={reqType.JobID}
                label={reqType.name} 
                {...reportsPageTabIds(reqType.JobID)} 
                sx={{
                  fontSize: '1rem', height: '40px', minHeight: '40px', fontSize: '12px', fontWeight: '600',
                  display: findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID', "IsActive") === 1
                    ? 'block'
                    : 'none',
                }}
                />
              ))}
            </Tabs>
          </Box>
          {reportsPageTabWithId.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getReportsPageContent(reqType.JobID, reqType.name)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}

export default GSReportsPage
